import styled from 'theme';

export const FormContentWrapper = styled.div`
  .input,
  .select,
  .textarea,
  .tag-input,
  .env-select {
    margin-bottom: 1.5rem;
  }

  .input--error,
  .select--error,
  .textarea--error,
  .tag-input--error,
  .env-select--error {
    margin-bottom: 0.22rem;
  }

  textarea {
    min-height: 8rem;
  }
`;
